module.exports = __webpack_public_path__ + "static/note-2-b5a0a92c8fe7addc2b88e53b801a6329.jpg";